import React from "react";
import { useParams } from "react-router-dom";
import ReportRoutes from "../report/report_routes";

const ConsultantReportRoutes = () => {
  const { organizationId } = useParams();

  return (
    <ReportRoutes
      isHub={false}
      basePathPrefix={`/app/consultant/organizations/${organizationId}/results`}
    />
  );
};

export default ConsultantReportRoutes;
